// FORMAT POSTAL CODE INPUT
const SERVICE_TIMESLOT = 'serviceTimeslot';
const formatServicePostalCode = function (postalCodeInput) {
    let timer;
    let lastSubmitted;

    const clearPostalInput = function (input, clearBtn, inputParent) {
        $(clearBtn).on('click', function () {
            lastSubmitted = "";
            $(this).removeClass('clear--active');
            $(inputParent).removeClass('field-error');
            $(input).val('').focus();
            $(this).closest('.st__postalCode__inputs').find('.postalCode_submit').prop('disabled', true);
            //Enlever les messages d'erreurs lors de la suppression du cp
            if ($(this).closest('.st__postalCode__inputs').find('.alert-no-service:not(.hide)').length) {
                $(this).closest('.st__postalCode__inputs').find('.alert-no-service').addClass('hide');
            } else if ($(this).closest('.st__postalCode__inputs').find('.alert-no-delivery-service:not(.hide)').length) {
                $(this).closest('.st__postalCode__inputs').find('.alert-no-delivery-service').addClass('hide');
            } else if ($(this).closest('.st__postalCode__inputs').find('.overlay-generic-error:not(.hide)').length) {
                $(this).closest('.st__postalCode__inputs').find('.overlay-generic-error').addClass('hide');
            } else if ($('.pb-2:not(.hide)').length) {
                $('.pb-2').addClass('hide');
            }

            if ($(input).is('#deliveryPostalCode')) {
                let $confirmService = $('#confirmService');
                let $checkBoxDelivery = $('#pickUpRadioFromUpdatePanel');

                if ($confirmService.length && $checkBoxDelivery.length && !$checkBoxDelivery.is(':checked')) {
                    $confirmService.prop('disabled', true);
                }
            }
        });
    }

    const formatInput = function (postalCodeInput, from) {
        lastSubmitted = $('#deliveryPostalCode').val();
        let $this = $(postalCodeInput);
        let $inputClearBtn = $this.siblings('.postalCode_clear');
        let $inputParent = $this.parent();
        let $inputSubmitBtn = $inputParent.parent().find('.postalCode_submit');

        let $checkBoxDelivery = $('#deliveryRadioFromUpdatePanel');
        let $checkBoxPickup = $('#pickUpRadioFromUpdatePanel');

        if ($checkBoxDelivery.length && $checkBoxPickup.length && $checkBoxDelivery.is(":disabled") && !$checkBoxPickup.is(":disabled")) {
            $checkBoxPickup.prop("checked", true);
            if ($('.list-pickup-from-panel').hasClass('hide')) {
                $('.list-pickup-from-panel').removeClass('hide');
            }
        }

        if (typeof lastSubmitted != 'undefined' && lastSubmitted.length && lastSubmitted.length === 7 && from === SERVICE_TIMESLOT) {
            $inputClearBtn.addClass('clear--active');
        }

        $this.mask('S0S 0S0');
        $this.on('keyup focus', function (event) {
            timer = setTimeout(validatePostalCode(this.value, $inputClearBtn, $inputParent, $inputSubmitBtn, event, from), 500);
        });

        clearPostalInput($this, $inputClearBtn, $inputParent);
    }

    function validatePostalCode(value, $inputClearBtn, $inputParent, $inputSubmitBtn, event, from) {
        let $confirmService = $('#confirmService');
        //le btn submit qui s'affiche pour recuperer la liste des pickup (panneau modifer cas cueillette)
        let $postalCodeSubmitPickupList = $('.postalCode_submit_pickup_list');
        let $confirmPostalCodePanel = $('.st--main:not(.choice-modification) .st__postalCode .postalCode_submit');

        $inputParent.removeClass('field-error');
        let postalLength = value.length;
        if (postalLength === 0) {
            if (from === SERVICE_TIMESLOT) {
                $inputSubmitBtn.prop('disabled', true);
                $postalCodeSubmitPickupList.prop('disabled', true);
                $inputClearBtn.removeClass('clear--active');
                $inputParent.removeClass('valid-format');

                if ($('#pickUpRadioFromUpdatePanel').length) {
                    $("#pickUpRadioFromUpdatePanel").prop("checked", false);
                }
                if ($('#deliveryRadioFromUpdatePanel').length) {
                    $("#deliveryRadioFromUpdatePanel").prop("checked", false);
                }

                let $checkBoxDelivery = $('#pickUpRadioFromUpdatePanel');
                if ($checkBoxDelivery.length && !$checkBoxDelivery.is(':checked')) {
                    $confirmService.prop('disabled', true);
                }
                if ($('input[name=radioServiceTypeFromUpdatePanel]').length) {
                    $('input[name=radioServiceTypeFromUpdatePanel]').prop('disabled', true);
                }
                if (('.list-pickup-from-panel') .length && !$('.list-pickup-from-panel').hasClass('hide')) {
                    $('.list-pickup-from-panel').addClass('hide');
                }
                lastSubmitted = "";

            } else {
                $inputSubmitBtn.prop('disabled', true);
                $inputClearBtn.removeClass('clear--active');
                $inputParent.removeClass('valid-format-overlay-completed');
                $inputSubmitBtn.show();
                $inputParent.parent().parent().find('.service-box_postal-actions > button').prop('disabled', true);
            }

        } else if (postalLength === 7) {
            if (from === SERVICE_TIMESLOT) {
                $inputParent.addClass('valid-format');
                $inputSubmitBtn.prop('disabled', false);
                $inputClearBtn.addClass('clear--active');
                if ($confirmService.length) {
                    $confirmService.prop('disabled', false);
                }
                if ($postalCodeSubmitPickupList.length) {
                    $postalCodeSubmitPickupList.prop('disabled', false);
                }
                if ($('#noService').length && $('#confirmService').length) {
                    $('#confirmService').prop('disabled', true);
                }

            } else {
                $inputParent.addClass('valid-format-overlay-completed');
                $inputClearBtn.addClass('postalCode_overlay_clear');
                $inputClearBtn.removeClass('postalCode_clear');
                $inputClearBtn.addClass('clear--active');
                $inputSubmitBtn.hide();

                if (event.type === 'keyup' && event.target.selectionStart === 7) {
                    $inputParent.parent().find('.loading-overlay-service-box').removeClass('hide');
                    $inputParent.removeClass('valid-format-overlay-completed');
                    $inputClearBtn.removeClass('postalCode_overlay_clear');
                    $inputParent.addClass('valid-format');
                    $inputClearBtn.addClass('postalCode_clear');
                    $inputSubmitBtn.hide();
                    $inputSubmitBtn.click();

                    if (event.key === 'Enter' || event.keyCode === 13) {
                        $('.delivery-section .service-box_postal-actions .cta-basic-primary.confirm').trigger('click');
                    }
                }
            }

            if ($confirmPostalCodePanel.length && !$confirmPostalCodePanel.hasClass('executed')) {
                $confirmPostalCodePanel.addClass('executed');
                $confirmPostalCodePanel.trigger('click');
            }

            if ($('#pickUpRadioFromUpdatePanel:checked').length && $('.postalCode_submit_pickup_list.cta-primary').length && $('#deliveryPostalCode').val() !== lastSubmitted) {
                lastSubmitted = $('#deliveryPostalCode').val();

                setTimeout(function () {
                    $('.st__postalCode__inputs .postalCode_submit_pickup_list.cta-primary').trigger('click');
                }, 300);
            }

            if ($('#deliveryRadioFromUpdatePanel:checked').length && $('#deliveryPostalCode').val() !== lastSubmitted) {
                lastSubmitted = $('#deliveryPostalCode').val();
                $('.st__postalCode__inputs .postalCode_submit_delivery.cta-primary').trigger('click');
            }

            if (!$('#deliveryRadioFromUpdatePanel:checked').length &&  !$('#pickUpRadioFromUpdatePanel:checked').length && $('#deliveryPostalCode').val() !== lastSubmitted) {
                lastSubmitted = $('#deliveryPostalCode').val();

                setTimeout(function () {
                    $('.st__postalCode__inputs .postalCode_submit_delivery.cta-primary').trigger('click');
                }, 300);
            }

        } else if (postalLength < 7 && postalLength > 0) {
            //cas FSA activé
            if (postalLength === 3) {

                let postalCodeSide = $('.st__postalCode__inputs #deliveryPostalCode');
                if (!postalCodeSide.length) {
                    $inputParent.focus();
                    $('#servicePostalCodeBox')[0].setSelectionRange(4, 4);
                }
                let $inputConfirmBtn = $('.service-box_postal-actions .confirm');
                $inputConfirmBtn.prop('disabled', true);
                if($confirmService.length){
                    $confirmService.prop('disabled', true);
                }
            }
            if (from === SERVICE_TIMESLOT) {
                $inputParent.removeClass('valid-format');
                $inputSubmitBtn.prop('disabled', true);
                $inputClearBtn.removeClass('clear--active');
                if ($confirmService.length) {
                    $confirmService.prop('disabled', true);
                }
                if ($postalCodeSubmitPickupList.length) {
                    $postalCodeSubmitPickupList.prop('disabled', true);
                }

                let $checkBoxDelivery = $('#deliveryRadioFromUpdatePanel');
                let $checkBoxPickup = $('#pickUpRadioFromUpdatePanel');

                if ($checkBoxDelivery.length && $checkBoxPickup.length) {
                    if (!$checkBoxDelivery.is(":disabled")) {
                        $checkBoxDelivery.prop('disabled', true);
                    }

                    if (!$checkBoxPickup.is(":disabled")) {
                        $checkBoxPickup.prop('disabled', true);
                    }
                }

                if ($('#noService').length) {
                    $('#noService').hide();
                }
                if (('.list-pickup-from-panel').length && !$('.list-pickup-from-panel').hasClass('hide')) {
                    $('.list-pickup-from-panel').addClass('hide');
                }
                lastSubmitted = "";
            } else {
                $inputParent.removeClass('valid-format-overlay-completed');
                $inputClearBtn.removeClass('postalCode_overlay_clear');
                $inputClearBtn.addClass('postalCode_clear');
                $inputClearBtn.removeClass('clear--active');
                $inputSubmitBtn.prop('disabled', true);
                $inputSubmitBtn.show();
                $inputParent.parent().parent().find('.service-box_postal-actions > button').prop('disabled', true);
            }
        }

        clearTimeout(timer);
    }

    return {
        formatInput: formatInput
    }
}();

const serviceTimeslotControl = function () {

//start alert tooltip new flyer
    function openTooltipFlyerModal($tooltipFlyerAction, $tooltipFlyerModal) {
        $tooltipFlyerAction.addClass('openAlert');
        $tooltipFlyerModal.removeClass('hide');
        TINK.trapFocus($tooltipFlyerModal, closeTooltipFlyerModal);
    }

    function closeTooltipFlyerModal() {
        $('.new--flyer--alert-tooltip .tooltip').removeClass('openAlert');
        $('.tooltipAlertNewFlyer').addClass('hide');
    }

    function openTooltipInterceptModal($tooltipFlyerIntercept, $overlayFlyerIntercept) {
        $tooltipFlyerIntercept.removeClass('hide');
        $overlayFlyerIntercept.removeClass('hide');
        let $liveRegion = $('#modal-live-region');
        let title = $tooltipFlyerIntercept.find('.tooltip-modal-new-flyer-title span').text();
        let message = $tooltipFlyerIntercept.find('.tooltip-modal-text').text();

        $liveRegion.text(title + '. ' + message);

        setTimeout(function() {
            $tooltipFlyerIntercept.find('button').focus();
        }, 100);

        TINK.trapFocus($tooltipFlyerIntercept, closeTooltipInterceptModal);
    }

    function closeTooltipInterceptModal() {
        $('.tooltipInterceptNewFlyer').addClass('hide');
        $('.overlay-tooltip-intercetp-new-flyer').addClass('hide');
        TINK.trapFocus($('#modal-service-and-timeslot'), closeServiceTimeslot);
    }

//end alert tooltip new flyer

    // INIT TIMESLOT DAY SLICK
    const initTimeslotDaySlider = function () {
        // link opening in mobile for instacart and uber
        if (isInWebview()) {
            $('.alert-container .alert-text a').on('click', function (e) {
                e.preventDefault();
                const forwardLink = $(this).prop("href");
                const backwardLink = null;
                sendRequestMobileLinkToOpenBrowserToDevice(forwardLink, backwardLink);
            });
        } else {
            serviceTimeSlotDays(onInitDaySlider, beforeChangeDaySlider, afterChangeDaySlider);
        }
        $('.day-selection_btn').on('click', function () {
            // Hide timeslot
            $this = $(this);
            var $activeDay = $('.activeDaySlider .day__active');
            var $timeslot = $(".activeTimeslotContainer .timeslotDayGroup." + sidePanelControl.getTimeslotByServiceTypeClass($activeDay));

            $timeslot.addClass("timeslot-group-inactive");

            // hide timeslot's alerts
            sidePanelControl.hideTimeslotAlert($timeslot);

            // unselect the current day
            $activeDay.removeClass('day__active');

            // conditions if not in Mprio mode -- display updates to timeslot
            if ($('.activeDaySlider').closest("[data-store-id]").attr('data-service-type') !== ServiceTimeslot.SERVICE_TYPE_MPRIORITY_DELIVERY) {
                let $elements = $('.select--delivery-service .lowest-fee-container, .express-delivery-choice, .alert-container.alert-express.alert-white, .fastest-tag, .cheapest-tag');
                let $lowestFeeContainer = $('.select--delivery-service .lowest-fee-container');
                let $categoryTagExpress = $('.category-tag-express').first();
                // elements to display on Today only
                if ($('.activeDaySlider .day-selection_btn.day__active').text() == 'Today' || $('.activeDaySlider .day-selection_btn.day__active').text() == 'Aujourd\'hui' || $(this).text() == 'Today' || $(this).text() == 'Aujourd\'hui') {
                    $lowestFeeContainer.show();
                    $elements.css('display', 'flex');
                    $categoryTagExpress.css('display', 'flex');
                } else {
                    $lowestFeeContainer.hide();
                    $elements.css('display', 'none');
                    $categoryTagExpress.css('display', 'none');
                    // if only express timeslot and no days row displayed
                    if (!$('.activeDaySlider').length) {
                        $elements.css('display', 'flex');
                        $categoryTagExpress.css('display', 'flex');
                        $('.lowest-fee-container').css('display', 'none');
                    }
                }

                $('.fastest-tag:gt(0)').remove();
            } else {
                // In mpriority mode nothing is displayed except Uber only if there is no See all timeslots button
                if (($('.activeDaySlider .day-selection_btn.day__active').text() == 'Today' || $('.activeDaySlider .day-selection_btn.day__active').text() == 'Aujourd\'hui' || $(this).text() == 'Today' || $(this).text() == 'Aujourd\'hui') &&
                    $('.showAllTimeslotText:not(.hide)').length === 0 && $('.activeTimeslotContainer ul[class*=service-home_delivery]').length === 0) {
                    $('.express-delivery-choice, .alert-container.alert-express.alert-white').css('display', 'flex');
                    let $categoryTagExpress = $('.category-tag-express').first();
                    $categoryTagExpress.css('display', 'flex');
                } else {
                    $('ul[class*=service-mpriority] .category-tag-partner, .lowest-fee-container, .activeTimeslotContainer .category-tag, .category-tag-express, .alert-container.alert-express.alert-white, .radio--standard.express-delivery-choice').css('display', 'none');
                }
            }

            //Show Timeslot
            sidePanelControl.showTimeslot($(this));

            let $btnParent = $this.parents('.slick-slide');
            if (!$btnParent.hasClass('slick-active') && !Revealizr.isMobileSize) {
                $('.activeDaySlider.slick-slider').slick('slickGoTo', $btnParent.data('slick-index'));
            }
        });
//start alert tooltip new flyer

        const $tooltipFlyerModal = $('.tooltipAlertNewFlyer');
        const $tooltipFlyerIntercept = $('.tooltipInterceptNewFlyer');
        const $tooltipFlyerClosed = $('.tooltip-alert-new-flyer .tooltip-modal button.modal__close');
        const $tooltipInterceptClosed = $('.tooltip-alert-new-flyer .tooltip-modal .confirmBtn');
        const $tooltipFlyerAction = $('.new--flyer--alert-tooltip .tooltip');
        const $overlayFlyerIntercept = $('.overlay-tooltip-intercetp-new-flyer');
        const $cheaperTomorrow = $('.select--delivery-service .lowestFeeBtn');
        const $changeType = $('.red-container .changeType');
        const $changeTypeService = $('.red-container .description-link');

        $tooltipFlyerAction.on('click', function () {
            if ($tooltipFlyerAction.hasClass('openAlert')) {
                closeTooltipFlyerModal();
            } else {
                openTooltipFlyerModal($tooltipFlyerAction, $tooltipFlyerModal);
            }
        });

        $tooltipFlyerClosed.on('click', function () {
            closeTooltipFlyerModal();
        })

        $tooltipInterceptClosed.on('click', function () {
            closeTooltipInterceptModal();
        })

        $overlayFlyerIntercept.on('click', function () {
            closeTooltipInterceptModal();
        })

        $cheaperTomorrow.on('click', function () {
            $('.selection-box-container.timeslotDeliveryContainer.activeTimeslotContainer .timeslotDayGroup').first().next().addClass('fromNoRush');
            $('button.day-selection_btn:contains(Tomorrow),button.day-selection_btn:contains(Demain)').first().click();
        })

        $changeType.click(function() {
            let $choiceTypeService = $('.st__serviceType input[name="radioServiceType"]:checked').val();
            let $deliveryPostalCode = $('#deliveryPostalCode').val();
            loadModifyPanel($choiceTypeService, $deliveryPostalCode);
        });

        $(document).off('click', '.red-container .no-tts-text-change-service').on('click', '.red-container .no-tts-text-change-service', function() {
            let $choiceTypeService = $('.st__serviceType input[name="radioServiceType"]:checked').val();
            let $deliveryPostalCode = $('#deliveryPostalCode').val();

            if ($choiceTypeService === 'HOME_DELIVERY'){
                $choiceTypeService = 'PICK_UP_IN_STORE';
            } else if ($choiceTypeService === 'PICK_UP_IN_STORE'){
                $choiceTypeService = 'HOME_DELIVERY';
            }

            loadModifyPanel($choiceTypeService, $deliveryPostalCode);
        });

        $changeTypeService.click(function() {
            let $choiceTypeService = $('.st__serviceType input[name="radioServiceType"]:checked').val();
            let $deliveryPostalCode = $('#deliveryPostalCode').val();

            if ($choiceTypeService === 'HOME_DELIVERY'){
                $choiceTypeService = 'PICK_UP_IN_STORE';
            } else if ($choiceTypeService === 'PICK_UP_IN_STORE'){
                $choiceTypeService = 'HOME_DELIVERY';
            }

            loadModifyPanel($choiceTypeService, $deliveryPostalCode);
        });

        $(document).click(function (event) {
            if (!$tooltipFlyerModal.hasClass('hide') && !$tooltipFlyerModal.is(event.target) && !$tooltipFlyerModal.has(event.target).length && !$tooltipFlyerAction.is(event.target) && !$tooltipFlyerAction.has(event.target).length) {
                closeTooltipFlyerModal();
            }
        });
//end alert tooltip new flyer
    }

    const onInitDaySlider = function () {
        timeslotDayControl();
        tabIndexCarrouselSet();
        instaCartAlert($('.activeTimeslotContainer .timeslotDayGroup li[data-timeslot-status=AVAILABLE] input:checked'));
    }

    const beforeChangeDaySlider = function () {
        let $firstDayActive = $('.activeDaySlider').find('.slick-active').first().find('.day-selection_btn');
        if ($firstDayActive.hasClass('day__active')) {
            $firstDayActive.removeClass('day__active');
            // hide timeslot
            var $timeslot = $(".activeTimeslotContainer .timeslotDayGroup." + sidePanelControl.getTimeslotByServiceTypeClass($firstDayActive));
            $timeslot.addClass("timeslot-group-inactive");
            // hide alerts
            sidePanelControl.hideTimeslotAlert($timeslot);
        }
    }

    const afterChangeDaySlider = function () {
        timeslotDayControl();
        tabIndexCarrouselSet();
        displayTssGridOptions();
    }

    const tabIndexCarrouselSet = function () {
        $('.timeslot-days-slick .slick-slide').each(function () {
            let $this = $(this);
            if ($this.hasClass('slick-active')) {
                $this.children('button').attr('tabindex', 0);
            } else {
                $this.children('button').attr('tabindex', -1);
            }
        });
    }

    // DAY SELECTION CONTROL
    const timeslotDayControl = function () {
        let $timeslotSlickList = $('.activeDaySlider');
        let $dayAlreadySelected = $('.activeDaySlider .day-selection_btn.day__active').length;
        let $daySlider = $('.timeslot-days-slick');
        let activeDayDataLabel;

        $daySlider.each(function () {
            $daySlider = $(this);
            activeDayDataLabel = $daySlider.data('aria-label');
            $daySlider.find('.slick-track').attr('aria-label', activeDayDataLabel);
        });

        if (!$dayAlreadySelected) {
            // TODO fix pour mobile
            let $firstActiveDay = $timeslotSlickList.find('.slick-active').first();
            let $selectionBtn = $firstActiveDay.find('.day-selection_btn');

            // Check if the selection btn is already initiated
            if ($selectionBtn.length > 0) {
                //Show Timeslot
                sidePanelControl.showTimeslot($selectionBtn);
            }
        }
    }

    const slickGoToDay = function (day) {
        let $timeslotSlickList = $('.activeDaySlider');
        if (!isInWebview() && !Revealizr.isMobileSize) {
            let index = $timeslotSlickList.find(".day-selection_btn[data-timeslot-date=" + day + "]").closest("[data-slick-index]").attr("data-slick-index");
            let currentIndex = $timeslotSlickList.find(".activeDaySlider .day__active").closest("[data-slick-index]").attr("data-slick-index");
            if (currentIndex - index !== 0 || $('.activeDaySlider .day__active').length === 0) {
                let slick = $timeslotSlickList.slick("slickGoTo", index);
                if ($('.activeDaySlider .day__active').length != 0) {
                    slick.find(".day-selection_btn[data-timeslot-date=" + day + "]").click();
                }
            }
        } else {
            let $activeDayButton = $(".activeDaySlider .day-selection_btn[data-timeslot-date=" + day + "]");
            $activeDayButton.click();
            let sliderWidth = $('.activeDaySlider').outerWidth();
            let activeDayOffsetLeft = ($activeDayButton.offset().left + $activeDayButton.outerWidth());
            if ($('.activeDaySlider .day__active').length != 0 && activeDayOffsetLeft > sliderWidth) {
                $timeslotSlickList.animate({scrollLeft: $activeDayButton.position().left - 20}, 500);
            }
        }
    }

    return {
        initTimeslotDaySlider: initTimeslotDaySlider,
        slickGoToDay: slickGoToDay,
        openTooltipInterceptModal: openTooltipInterceptModal
    }
}();

let pannelIsOpen = true;
const sidePanelControl = function () {
    let isFlexTimeslotService;

    function getTimeslotServiceTypeByClass($element) {

        if ($element === undefined || $element.attr("class") == undefined) {
            return null;
        }
        // show timeslot
        let classes = $element.attr("class").split(" ");
        // Filter classes that have "service" as a prefix
        return classes.filter(function (className) {
            return className.startsWith("service");
        });
    }

    function getTimeslotSelectorByServiceTypeAndDay(serviceType, day) {
        // example : service-pickup-2023-09-28
        return "service-" + serviceType + "-" + day;
    }

    function isFlexiblePickup() {
        return $('.activeDaySlider').closest("[data-store-id]").attr('data-service-type') === ServiceTimeslot.SERVICE_TYPE_MPRIORITY_PICKUP;
    }

    function isPickup() {
        return $('.activeDaySlider').closest("[data-store-id]").attr('data-service-type') === ServiceTimeslot.SERVICE_TYPE_ECOMM_PICKUP;
    }

    function isDelivery() {
        return $('.activeDaySlider').closest("[data-store-id]").attr('data-service-type') === ServiceTimeslot.SERVICE_TYPE_ECOMM_DELIVERY;
    }

    function isFlexibleDelivery() {
        return $('.activeDaySlider').closest("[data-store-id]").attr('data-service-type') === ServiceTimeslot.SERVICE_TYPE_MPRIORITY_DELIVERY;
    }

    function isCurrentDayInNewFlyerCoverage() {
        let $activeDayBtn = $('.activeDaySlider .day-selection_btn.day__active');
        return $activeDayBtn.length && $activeDayBtn.data('new-flyer-coverage') === true;
    }

    function showTimeslotAlert($target) {
        let inNewFlyerCoverage = isCurrentDayInNewFlyerCoverage();
        let displayNewFlyerExcludedAlert = inNewFlyerCoverage && typeof newFlyerTimeslotsExcluded !== 'undefined' && newFlyerTimeslotsExcluded;

        if ($target.closest('.select--delivery-service').length > 0) {
            $('.select--delivery-service .timeslotAlert').addClass("hide");

            if (displayNewFlyerExcludedAlert) {
                $('.deliveryErrorNewFlyerAlert').removeClass('hide');
                $('.deliveryErrorNewFlyerAlert').find('div').focus();
            } else {
                if ($target.children().length === 0 && isDelivery()) {
                    if ($('#pickUpRadio[disabled]').length) {
                        $('.tryPickUp').addClass('hide');
                    } else {
                        $('.tryPickUp').removeClass('hide');
                    }

                    // don't show lowest fee tomorrow and any alert together
                    if ($('.lowest-fee-container').length === 0 || $('.lowest-fee-container').css('display') == 'none') {
                        if (inNewFlyerCoverage) {
                            $('.timeslotAlert.deliveryTimeslotNewFlyerAlert').removeClass("hide");
                        } else {
                            $('.timeslotAlert.deliveryTimeslotAlert').removeClass("hide");
                        }
                    }
                } else if ($target.children().length === 0 && isFlexibleDelivery()) {
                    if (inNewFlyerCoverage) {
                        $('.timeslotAlert.flexibleDeliveryTimeslotNewFlyerAlert').removeClass("hide");
                    } else {
                        $('.timeslotAlert.flexibleDeliveryTimeslotAlert').removeClass("hide");
                    }
                }
            }
        } else if ($target.closest('.select--pickup-service').length > 0) {
            $('.select--pickup-service .timeslotAlert').addClass("hide");

            if (isFlexiblePickup()) {
                $('.select--pickup-service .flexibleDeliveryTitle').removeClass('hide');
            } else {
                $('.select--pickup-service .flexibleDeliveryTitle').addClass('hide');
            }

            if (displayNewFlyerExcludedAlert) {
                $('.pickupErrorNewFlyerAlert').removeClass('hide');
                $('.pickupErrorNewFlyerAlert').find('div').focus();
            } else {
                if ($target.children().length === 0 && isPickup()) {
                    if ($('#deliveryRadio[disabled]').length) {
                        $('.tryDelivery').addClass('hide');
                    } else {
                        $('.tryDelivery').removeClass('hide');
                    }
                    if (inNewFlyerCoverage) {
                        $('.timeslotAlert.pickupTimeslotNewFlyerAlert').removeClass("hide");
                    } else {
                        $('.timeslotAlert.pickupTimeslotAlert').removeClass("hide");
                    }
                } else if ($target.children().length === 0 && isFlexiblePickup()) {
                    if (inNewFlyerCoverage) {
                        $('.timeslotAlert.flexiblePickupTimeslotNewFlyerAlert').removeClass("hide");
                    } else {
                        $('.timeslotAlert.flexiblePickupTimeslotAlert').removeClass("hide");
                    }
                }
            }
        }
    }

    function hideTimeslotAlert($target) {
        if ($target.closest('.select--delivery-service').length > 0) {
            $('.timeslotAlert.deliveryTimeslotAlert').addClass("hide");
            $('.timeslotAlert.deliveryTimeslotNewFlyerAlert').addClass("hide");
            $('.timeslotAlert.flexibleDeliveryTimeslotAlert').addClass("hide");
            $('.timeslotAlert.flexibleDeliveryTimeslotNewFlyerAlert').addClass("hide");
            $('.timeslotAlert.deliveryErrorNewFlyerAlert').addClass("hide");
        } else if ($target.closest('.select--pickup-service').length > 0) {
            $('.timeslotAlert.pickupTimeslotAlert').addClass("hide");
            $('.timeslotAlert.pickupTimeslotNewFlyerAlert').addClass("hide");
            $('.timeslotAlert.flexiblePickupTimeslotAlert').addClass("hide");
            $('.timeslotAlert.flexiblePickupTimeslotNewFlyerAlert').addClass("hide");
            $('.timeslotAlert.pickupErrorNewFlyerAlert').addClass("hide");
        }
    }

    function showTimeslot($targetBtn) {
        if ($targetBtn.attr('data-timeslot-isloaded') === 'true') {
            // select this day
            $targetBtn.addClass('day__active');

            let timeslotClass = getTimeslotServiceTypeByClass($targetBtn);
            // Show timeslot
            var $timeslot = $(".activeTimeslotContainer .timeslotDayGroup." + timeslotClass);

            $timeslot.removeClass("timeslot-group-inactive");
            showTimeslotAlert($timeslot);
        } else {
            loadAndShowFirstAvailableTimeslot($targetBtn);
        }
    }

    function getLoadedDays($target) {
        return $($target).find("[data-timeslot-isloaded='true']").map(function () {
            return $(this).data("timeslot-date");
        }).get();
    }

    // Load timeslot std and flexible
    function loadAndShowFirstAvailableTimeslot($serviceToggle) {
        var serviceType = $serviceToggle.closest("[data-store-id]").attr('data-service-type');
        var selectedDay = $serviceToggle.data("timeslot-date");
        var loadedTimeslotDays;
        var serviceCssClass;
        var isMultiChoice;
        var standardStoreId;
        var standardServiceType;
        var standardServicePointId;
        var flexibleStoreId;
        var flexibleServiceType;
        var flexibleServicePointId;

        if (serviceType === "HOME_DELIVERY") {
            serviceCssClass = ".timeslotDeliveryContainer";

            isMultiChoice = false;

            standardStoreId = $serviceToggle.closest("[data-service-type='HOME_DELIVERY']").attr('data-store-id');
            standardServiceType = $serviceToggle.closest("[data-service-type='HOME_DELIVERY']").attr('data-service-type');
            standardServicePointId = $serviceToggle.closest("[data-service-type='HOME_DELIVERY']").attr('data-service-point-id');

            loadedTimeslotDays = getLoadedDays(".section-day-selection .selectDeliveryStore[data-service-type=" + standardServiceType + "][data-store-id=" + standardStoreId + "]");

        } else if (serviceType === "MPRIORITY_HOME_DELIVERY") {
            serviceCssClass = ".timeslotDeliveryContainer";
            isMultiChoice = false;

            flexibleStoreId = $serviceToggle.closest("[data-service-type='MPRIORITY_HOME_DELIVERY']").attr('data-store-id');
            flexibleServiceType = $serviceToggle.closest("[data-service-type='MPRIORITY_HOME_DELIVERY']").attr('data-service-type');
            flexibleServicePointId = $serviceToggle.closest("[data-service-type='MPRIORITY_HOME_DELIVERY']").attr('data-service-point-id');

            loadedTimeslotDays = getLoadedDays(".section-day-selection .selectDeliveryStore[data-service-type=" + flexibleServiceType + "][data-service-point-id=" + flexibleServicePointId + "][data-store-id=" + flexibleStoreId + "]");

        } else if (serviceType === "PICK_UP_IN_STORE" || serviceType === "MPRIORITY_PICKUP") {
            serviceCssClass = ".timeslotPickupContainer";

            isMultiChoice = $serviceToggle.closest("[data-store-id]").attr('data-flexible-service-point-id') && $serviceToggle.closest("[data-store-id]").attr('data-pickup-service-point-id');

            standardStoreId = $serviceToggle.closest("[data-store-id]").attr('data-store-id');
            standardServiceType = $serviceToggle.closest("[data-store-id]").attr('data-pickup-service-type');
            standardServicePointId = $serviceToggle.closest("[data-store-id]").attr('data-pickup-service-point-id');

            flexibleStoreId = standardStoreId;
            flexibleServiceType = $serviceToggle.closest("[data-store-id]").attr('data-flexible-service-type');
            flexibleServicePointId = $serviceToggle.closest("[data-store-id]").attr('data-flexible-service-point-id');

            loadedTimeslotDays = getLoadedDays(".section-day-selection .select--pickup-store[data-store-id=" + standardStoreId + "]");
        }

        loadStandardAndFlexibleTimeslots($serviceToggle, standardServiceType, standardStoreId, standardServicePointId, flexibleServiceType, flexibleStoreId, flexibleServicePointId, selectedDay, loadedTimeslotDays, serviceCssClass, isMultiChoice, (serviceType === "PICK_UP_IN_STORE" || serviceType === "HOME_DELIVERY"));
    }

    function loadStandardAndFlexibleTimeslots($serviceToggle, firstServiceType, firstStoreId, firstServicePointId, secondServiceType, secondStoreId, secondServicePointId, selectedDay, loadedTimeslotDays, serviceCssClass, isMultiChoice, showFlexibleBtn) {
        let isDelivery = (firstServiceType === "HOME_DELIVERY" || secondServiceType === "MPRIORITY_HOME_DELIVERY");

        if (firstServicePointId || firstServiceType === ServiceTimeslot.SERVICE_TYPE_ECOMM_DELIVERY) {
            loadTimeslots($serviceToggle, firstServiceType, firstStoreId, firstServicePointId, selectedDay, loadedTimeslotDays, serviceCssClass, isDelivery);
        } else if (secondServicePointId) {
            loadTimeslots($serviceToggle, secondServiceType, secondStoreId, secondServicePointId, selectedDay, loadedTimeslotDays, serviceCssClass, isDelivery);
        }

        if (isMultiChoice) {
            ServiceTimeslot.loadTimeslots(secondServiceType, secondStoreId, secondServicePointId, selectedDay, loadedTimeslotDays, serviceCssClass, getTimeslotServiceTypeByClass, isDelivery);
            if (showFlexibleBtn) {
                if (isDelivery) {
                    ServiceTimeslot.manageBtnShowFlexible('delivery', true);
                } else {
                    ServiceTimeslot.manageBtnShowFlexible('pickup', true);
                }
            }
        }
    }

    function loadTimeslots($this, serviceType, storeId, servicePointId, selectedDay, loadedTimeslotDays, serviceCssClass, isDelivery) {
        ServiceTimeslot.loadTimeslots(serviceType, storeId, servicePointId, selectedDay, loadedTimeslotDays, serviceCssClass, getTimeslotServiceTypeByClass, isDelivery)
            .then(function (data) {
                if (selectedDay) {
                    $this.addClass('day__active');

                    // Show timeslot using get timeslot class
                    var $timeslot = $(".activeTimeslotContainer .timeslotDayGroup." + getTimeslotServiceTypeByClass($this));
                    $timeslot.removeClass("timeslot-group-inactive");

                    showTimeslotAlert($timeslot);
                    getRadioOnChange();
                } else {
                    let $daysCarousel = $('.section-day-selection').find("[data-service-type=" + serviceType + "]").closest("[data-service-point-id=" + servicePointId + "],[data-store-id=" + storeId + "]");
                    if (ServiceTimeslot.getCurrentServiceType() === serviceType || ServiceTimeslot.getCurrentServiceType() === ServiceTimeslot.SERVICE_TYPE_EXPRESS_DELIVERY) {
                        // get the first btn of the available timeslot
                        let $firstDayActive = $daysCarousel.find('[data-timeslot-status=AVAILABLE]').first();
                        if ($firstDayActive.length === 0 || $firstDayActive.attr('data-timeslot-isloaded') === 'false') {
                            // if there is no timeslot available for all loaded days, then get the first anyway
                            $firstDayActive = $daysCarousel.first().find('.day-selection_btn').first();
                        }
                        $daysCarousel.find('.day-selection_btn').removeClass('day__active');
                        // select the new btn
                        $firstDayActive.addClass('day__active');
                        // Show timeslot using get timeslot class
                        var $timeslot = $(".activeTimeslotContainer .timeslotDayGroup." + getTimeslotServiceTypeByClass($firstDayActive));
                        $timeslot.removeClass("timeslot-group-inactive");

                        checkTimeslotRadioInput(serviceType, $timeslot);
                        // Show timeslot Alert
                        showTimeslotAlert($timeslot);
                    }
                    getRadioOnChange();

                    // change data-init-timeslot status
                    $daysCarousel.attr("data-init-timeslot", "true");
                    // change data-init-timeslot status for select pickup stores
                    if (serviceType === "PICK_UP_IN_STORE") {
                        // TODO improve me by using the selector activePickupStore
                        let $listPickup = $(".selection-box.select--pickup-service input[name='pickUpStoreSelect']:checked[data-store-id=" + storeId + "]");
                        $listPickup.attr("data-init-timeslot", "true");
                    }
                }
                if (serviceType !== "PICK_UP_IN_STORE") {
                    displayTssGridOptions();
                }
            })
    }

    function showFirstAvailableTimeslot() {
        let serviceTypeChecked = ServiceTimeslot.getToggleServiceType();
        // get the first day btn of the available timeslot
        let $firstDayActive = getFirstAvailableDay();

        if ($firstDayActive.length > 0) {
            $(".activeDaySlider .day-selection_btn").removeClass('day__active');
            // select the new btn
            $firstDayActive.addClass('day__active');

            showLoadedTimeslotBySelector(getTimeslotServiceTypeByClass($firstDayActive), serviceTypeChecked);
        }
    }

    function showLoadedTimeslotBySelector($dayBtnSelector, $serviceTypeChecked) {
        var $timeslot = $(".activeTimeslotContainer .timeslotDayGroup." + $dayBtnSelector);
        // Hide all timeslots
        $timeslot.closest('.selection-box-container.activeTimeslotContainer').find('.timeslotDayGroup').addClass("timeslot-group-inactive");
        // Show timeslot of the selected day
        $timeslot.removeClass("timeslot-group-inactive");

        checkTimeslotRadioInput($serviceTypeChecked, $timeslot);
        // Show timeslot Alert
        showTimeslotAlert($timeslot);
    }

    function getFirstAvailableDay(timeslotStatus) {
        let serviceType = ServiceTimeslot.getCurrentServiceType();
        if (timeslotStatus === undefined && serviceType === ServiceTimeslot.SERVICE_TYPE_MPRIORITY_PICKUP) {
            timeslotStatus = "data-timeslot-flexible-status";
        }
        if (timeslotStatus === undefined) {
            timeslotStatus = 'data-timeslot-status';
        }

        // get the first day btn of the available timeslot
        let $firstDayActive = $('.activeDaySlider').find('[' + timeslotStatus + '=AVAILABLE]').first();
        if ($firstDayActive.length === 0 || $firstDayActive.attr('data-timeslot-isloaded') === 'false') {
            // if there is no timeslot available for all loaded days, then get the first anyway
            $firstDayActive = $('.activeDaySlider').first().find('.day-selection_btn').first();
        }

        if ($firstDayActive.length > 0 && $firstDayActive.text() !== 'Today' && $firstDayActive.text() !== 'Aujourd\'hui' &&
            (serviceType === 'HOME_DELIVERY' || serviceType === 'MPRIORITY_HOME_DELIVERY')) {
            // if there is no timeslot available for today, we are looking for uber
            let $timeslotExpress = $('input[name="select-timeslot-express_delivery"]');
            if ($timeslotExpress.length) {
                $firstDayActive = $('.activeDaySlider').first().find('.day-selection_btn').first();
            }
        }

        return $firstDayActive;
    }

    function goToReservedTimeslot($timeslotSelected) {
        let $timeslotSelectedClass = sidePanelControl.getTimeslotByServiceTypeClass($timeslotSelected);
        if ($timeslotSelectedClass) {
            let $activeDaySlider = $('.timeslot-days-slick.activeDaySlider').find('.' + $timeslotSelectedClass[0]);
            if ($activeDaySlider.length) {
                ServiceTimeslot.setCurrentServiceType();
                serviceTimeslotControl.slickGoToDay($activeDaySlider.attr("data-timeslot-date"));
            }
        }
        return $timeslotSelectedClass[0];
    }

    function initServiceTypeExpressDelivery() {
        let $serviceTypeChecked = $('.st__serviceType input[name="radioServiceType"]:checked').val();
        if (($serviceTypeChecked == 'HOME_DELIVERY' && $('.express-delivery-choice input:checked').length) ||
            ($serviceTypeChecked == 'HOME_DELIVERY' && $('.standard-timeslots-home_delivery').length == 0 && $('.express-delivery-choice input').length)) {
            $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type', 'eclair');
        }
    }

    function displayCorrectTimeslotDay(onInit) {
        let $timeslotSelected = $('[data-timeslot-selected=true]').closest('.timeslotDayGroup ');

        if (isFlexTimeslotService === undefined) {
            isFlexTimeslotService = false;
        }

        if ($timeslotSelected.length) {
            if (onInit && (serviceType && serviceType.toUpperCase() === ServiceTimeslot.SERVICE_TYPE_MPRIORITY_PICKUP || serviceType && serviceType.toUpperCase() === ServiceTimeslot.SERVICE_TYPE_MPRIORITY_DELIVERY)) {
                isFlexTimeslotService = true;
                return $('.showTimeslotFlexible').click();
            }
            let $timeslotSelectedClass = sidePanelControl.getTimeslotByServiceTypeClass($timeslotSelected);
            if ($timeslotSelectedClass) {
                let $activeDaySlider = $('.timeslot-days-slick.activeDaySlider').find('.' + $timeslotSelectedClass[0]);
                if ($activeDaySlider.length) {
                    ServiceTimeslot.setCurrentServiceType();
                    serviceTimeslotControl.slickGoToDay($activeDaySlider.attr("data-timeslot-date"));
                }
            }
            if (isFlexTimeslotService !== true) {
                onPanelViewPush();
            }

            return $timeslotSelectedClass[0];
        }
        onPanelViewPush();
    }

    function manageAlertDisplay(timeslotSelected) {
        if (timeslotSelected.hasClass('standard-timeslots-express_delivery')) {
            showExpressAlert();
        } else if (timeslotSelected.hasClass('standard-timeslots-mpriority_home_delivery')) {
            flexibleServiceAlert(timeslotSelected, true);
            hideExpressAlert();
        } else if (timeslotSelected.hasClass('standard-timeslots-mpriority_pickup')) {
            flexibleServiceAlert(timeslotSelected, false);
            hideExpressAlert();
        } else {
            hideExpressAlert();
        }
    }

    function checkTimeslotRadioInput($serviceTypeChecked, $timeslot) {
        let $inputTimeslotToCheck;
        let $timeslotContainer;
        let $footerReservedSlot = $('.footerReservedSlot');
        //Le type de livraison choisie dans le overlay, il faut se positionner a la bonne Ts choisie dans le panneau de droite
        let $preselectedTsFromOverlay = $('.preselectedTsFromOverlay');
        let $serviceTypesDelivery = $serviceTypeChecked == 'HOME_DELIVERY' || $serviceTypeChecked == 'MPRIORITY_HOME_DELIVERY';
        let $serviceTypesPickup = $serviceTypeChecked == 'PICK_UP_IN_STORE' || $serviceTypeChecked == 'MPRIORITY_PICKUP';
        let $serviceTypeExpress = $('input[name="select-timeslot-express_delivery"]:checked');
        let currentServiceType = $('.activeDaySlider').closest("[data-store-id]").attr('data-service-type');
        if ($serviceTypesDelivery) {
            $timeslotContainer = '.timeslotDeliveryContainer';
        } else if ($serviceTypesPickup) {
            $timeslotContainer = '.timeslotPickupContainer';
        }

        if ($serviceTypesPickup || !$serviceTypeExpress.length) {
            let $timeslotAlreadySelected;
            if (currentServiceType === $footerReservedSlot.attr('data-reserved-serviceType') || (typeof $preselectedTsFromOverlay.attr("data-slot-reserved-id") !== 'undefined')) {
                // get reserved timeslot
                $timeslotAlreadySelected = $($timeslotContainer + '.activeTimeslotContainer').find('[data-timeslot-selected=true]');
            }
            if ($timeslotAlreadySelected === undefined || !$timeslotAlreadySelected.length) {
                // check the first available timeslot radio input when no timeslot is already selected
                let $firstAvailableTimeslot = $timeslot.find('li').data('data-timeslot-status', 'AVAILABLE').first();
                if ($firstAvailableTimeslot.length) {
                    let $preselectedTimeslot = $timeslot.find('.preselected-timeslot').data('data-timeslot-status', 'AVAILABLE').first();
                    if ($preselectedTimeslot.length) {
                        $inputTimeslotToCheck = $preselectedTimeslot.find('input');
                    } else {
                        $inputTimeslotToCheck = $firstAvailableTimeslot.find('input');
                    }
                    $inputTimeslotToCheck.prop('checked', true);
                    instaCartAlert($inputTimeslotToCheck);
                    instaCartAlertExpress($inputTimeslotToCheck);
                    setGaDataTypes($inputTimeslotToCheck);
                    ServiceTimeslot.manageFooterInfo($inputTimeslotToCheck, false);
                } else {
                    disableConfirmTimeslotButton(true);
                }
                $footerReservedSlot.hide();
            } else {
                let $selectedSlot = $timeslotAlreadySelected.find('input');
                $timeslotAlreadySelected.find('input').prop('checked', true);
                displayReservedTag($selectedSlot);
                manageAlertDisplay($selectedSlot);
                instaCartAlert($selectedSlot);
                instaCartAlertExpress($selectedSlot);
                setGaDataTypes($selectedSlot);

                if ($footerReservedSlot.attr('data-slot-reserved-id')) {
                    disableConfirmTimeslotButton(true);
                } else {
                    disableConfirmTimeslotButton(false);
                }
            }
        } else if ($serviceTypeExpress.length) {
            manageAlertDisplay($('input[name="select-timeslot-express_delivery"]'));
            if ($serviceTypeExpress.attr('data-express-delivery-is-reserved') == 'true') {
                displayReservedTag($serviceTypeExpress);
            }
        }
    }

    const closeStoreToggle = function () {
        $('.pickupStoreSelection').removeClass('active');
        $('#timeslotStoreSelect').attr('aria-expanded', false);
        $('.pickupStoreSelection .accordion--text').hide();
    }

    const closeFlexibleDeliveryDropdown = function () {
        $('.flexibleDeliveryDropdown').removeClass('active');
        $('#selectedFlexibleDeliveryStore').attr('aria-expanded', false);
        $('.flexibleDeliveryDropdown .accordion--text').hide();
    }

    const storeSelectToggle = function () {
        let $toggleStoreSelect = $('#timeslotStoreSelect');
        let $flexibleDeliverySelect = $('#selectedFlexibleDeliveryStore');
        let $container = $(".pickupStoreSelection");
        let $flexibleDeliveryContainer = $(".flexibleDeliveryDropdown");
        let toggleStoreSelectActive;
        let clickedElm;
        let clickBool;

        $($toggleStoreSelect).on('click', function () {
            $(document).mouseup(function (e) {
                toggleStoreSelectActive = $toggleStoreSelect.attr('aria-expanded');

                if (toggleStoreSelectActive === 'true') {
                    clickedElm = e.target;
                    clickBool = $container.find(clickedElm).length;
                    if (!clickBool) {
                        closeStoreToggle();
                        return;
                    }
                }
            });
        });

        $($flexibleDeliverySelect).on('click', function () {
            $(document).mouseup(function (e) {
                toggleStoreSelectActive = $flexibleDeliverySelect.attr('aria-expanded');

                if (toggleStoreSelectActive === 'true') {
                    clickedElm = e.target;
                    clickBool = $flexibleDeliveryContainer.find(clickedElm).length;
                    if (!clickBool) {
                        closeFlexibleDeliveryDropdown();
                        return;
                    }
                }
            });
        });
    }

    const remodalCloseEvent = function () {
        let $serviceTimeslotContainer = $('[data-remodal-id=serviceTimeSlotPanel]');
        if ($serviceTimeslotContainer.length) {
            let inst;
            let remodalElm = document.querySelector('.st_panel');

            var observer = new MutationObserver(function (mutations) {
                inst = $.remodal.lookup[$serviceTimeslotContainer.data('remodal')];

                if (inst.state === 'opened') {
                    ServiceTimeslot.bindCloseButton();
                }

                if (inst.state === 'closing') {
                    // On close servicetimeslot event
                    ServiceTimeslot.onCloseModalServiceAndTimeslot();
                    pannelIsOpen = true;
                }
            });

            observer.observe(remodalElm, {
                attributes: true,
                childList: false,
                characterData: false
            });
        }
    }

    const showExpressAlert = function () {
        $('.alert-express').removeClass('hide');
        $('.flexibletAlert-Active').remove();
        if ($('#modal-service-and-timeslot .st--main').data('express-item-entry') > $('#modal-service-and-timeslot .st--main').data('max-item-number')) {
            $('.expressMaxItemsAlert').removeClass('hide');
            disableChooseLaterButton(true);
            disableConfirmTimeslotButton(true);
        } else if ($('.st--footer .footerReservedSlot:visible').length) {
            disableConfirmTimeslotButton(true);
        } else {
            disableConfirmTimeslotButton(false);
        }
    }

    const hideExpressAlert = function () {
        $('.alert-express').addClass('hide');
        $('.expressMaxItemsAlert').addClass('hide');
    }

    const showPostalCodeNotSubmittedAlert = function () {
        $('.postalCodeNotSubmittedAlert').removeClass('hide');
    }

    const hidePostalCodeNotSubmittedAlert = function () {
        $('.postalCodeNotSubmittedAlert').addClass('hide');
    }

    function closeFlexibleAlert(alert) {
        let $this = alert;
        let $closeBtn = $this.find('.alert-close');

        $($closeBtn).on('click', function () {
            $(this).parent('.alert-container').remove();
            $('.timeslot-bottom-border').removeClass('timeslot-bottom-border');
            $('.timeslot-top-border').removeClass('timeslot-top-border');
        });
    }

    function flexibleServiceAlert(elm, delivery) {
        $('.flexibletAlert-Active').remove();
        $('.timeslot-bottom-border').removeClass('timeslot-bottom-border');
        $('.timeslot-top-border').removeClass('timeslot-top-border');
        let inputParent = elm.closest('li');
        let $flexibleAlert = $('.flexibleServiceAlert');
        let cloneFlexibleAlert = $flexibleAlert.clone();
        inputParent.addClass('timeslot-top-border');
        inputParent.prev('li').addClass('timeslot-bottom-border');
        cloneFlexibleAlert.find('.cloneFlexibleAlert').addClass('hide');
        cloneFlexibleAlert.removeClass('hide').addClass('flexibletAlert-Active');
        cloneFlexibleAlert.insertAfter(inputParent);
        if (delivery) {
            cloneFlexibleAlert.find('.flexibleAlertDelivery').removeClass('hide');
        } else {
            cloneFlexibleAlert.find('.flexibleAlertPickUp').removeClass('hide');
        }

        closeFlexibleAlert(cloneFlexibleAlert);
    }

    function displayReservedTag(reservedSlot) {
        $('.footerReservedSlot').show();

        if ($('.timeslotReserved').length === 0) {
            let $reservedTag = $('.reserved-slot').clone();
            let $labelContainer = reservedSlot.siblings('.radio--label').find('span')[0];
            $reservedTag.removeClass('footerReservedSlot');
            $reservedTag.addClass('timeslotReserved');
            $reservedTag.insertAfter($labelContainer);
        }
    }

    function disableConfirmTimeslotButton(disable) {
        $('#confirmTimeslot').prop('disabled', disable);
    }

    function disableChooseLaterButton(disable) {
        $('#chooseLater').prop('disabled', disable);
    }

    const onPanelViewPush = function () {
        if (pannelIsOpen) {
            pannelIsOpen = false;
            // Delay of 550ms after the slickGoTo animation before triggering the panelviewGApush event
            setTimeout(panelViewGAPush, 550);
        }
    }

    return {
        showTimeslot: showTimeslot,
        showTimeslotAlert: showTimeslotAlert,
        hideTimeslotAlert: hideTimeslotAlert,
        getTimeslotByServiceTypeClass: getTimeslotServiceTypeByClass,
        loadAndShowFirstAvailableTimeslot: loadAndShowFirstAvailableTimeslot,
        showFirstAvailableTimeslot: showFirstAvailableTimeslot,
        getTimeslotSelectorByServiceTypeAndDay: getTimeslotSelectorByServiceTypeAndDay,
        initServiceTypeExpressDelivery: initServiceTypeExpressDelivery,
        storeSelectToggle: storeSelectToggle,
        closeStoreToggle: closeStoreToggle,
        closeFlexibleDeliveryDropdown: closeFlexibleDeliveryDropdown,
        remodalCloseEvent: remodalCloseEvent,
        displayCorrectTimeslotDay: displayCorrectTimeslotDay,
        checkTimeslotRadioInput: checkTimeslotRadioInput,
        getFirstAvailableDay: getFirstAvailableDay,
        showExpressAlert: showExpressAlert,
        hideExpressAlert: hideExpressAlert,
        showPostalCodeNotSubmittedAlert: showPostalCodeNotSubmittedAlert,
        hidePostalCodeNotSubmittedAlert: hidePostalCodeNotSubmittedAlert,
        flexibleServiceAlert: flexibleServiceAlert,
        isDelivery: isDelivery,
        manageAlertDisplay: manageAlertDisplay,
        displayReservedTag: displayReservedTag,
        disableConfirmTimeslotButton: disableConfirmTimeslotButton,
        disableChooseLaterButton: disableChooseLaterButton,
        showLoadedTimeslotBySelector: showLoadedTimeslotBySelector,
        goToReservedTimeslot: goToReservedTimeslot,
        isCurrentDayInNewFlyerCoverage: isCurrentDayInNewFlyerCoverage,
        onPanelViewPush: onPanelViewPush
    }
}();

const toggleServiceAction = function (isServiceTypeDelivery) {
    if (isServiceTypeDelivery) {
        $('.footerDelivery').show();
        $('.footerPickup').hide();
        $('.data-container-GA .data-service-type-GA').data('ga-service-type', 'delivery');

        let $expressDeliveryInput = $('input[name=select-timeslot-express_delivery]:checked');
        let $flexibleDeliveryInput = $('input[name= select-timeslot-mpriority_home_delivery]:checked');
        let $instaCartDeliveryInput = $('input.instacart-slot:checked');
        if ($expressDeliveryInput.length) {
            sidePanelControl.manageAlertDisplay($expressDeliveryInput);
            if ($expressDeliveryInput.attr('data-express-delivery-is-reserved') == 'true') {
                sidePanelControl.displayReservedTag($expressDeliveryInput);
            }
        } else if ($flexibleDeliveryInput.length) {
            sidePanelControl.manageAlertDisplay($flexibleDeliveryInput);
        } else if ($instaCartDeliveryInput.length) {
            instaCartAlert($instaCartDeliveryInput);
        }

        displayTssGridOptions();
    } else {
        $('.footerDelivery').hide();
        $('.footerPickup').show();
        $('.alert-express').addClass('hide');
        $('.data-container-GA .data-service-type-GA').data('ga-service-type', 'pick-up');
        let $flexiblePickupInput = $('input[name=select-timeslot-mpriority_pickup]:checked');
        if ($flexiblePickupInput.length) {
            sidePanelControl.manageAlertDisplay($flexiblePickupInput);
        }
    }
}

//Panneau de droite pr modifier un cp
function loadModifyPanel(choiceTypeService, deliveryPostalCode) {
    $.ajax({
        url: overlayTypeChoiceUrl +'?choiceTypeService='+ choiceTypeService +'&deliveryPostalCode='+deliveryPostalCode,
        type: 'GET',
        contentType: 'application/json',
        dataType: 'html',
        cache: true,
        success: function (data, jqXHR) {
            $('.st_panel.rightPanel').html(data);
            let $choiceTypeService = $('.st__serviceType input[name="radioServiceTypeFromUpdatePanel"]:checked').val();
            if ($choiceTypeService === 'PICK_UP_IN_STORE') {
                $('.dropdown--list-stores').removeClass('hide');
                $('.postalCode_submit_pickup_list').removeClass('hide');
            }
            onPanelView('product tile overlay', false);
            initServiceTimeslot();
        },
        error: function (jqXHR) {
            TINK.redirectIfConflict(jqXHR);
        }
    });
}

//Panneau modification, la soummision soit pour une livraison, ou pr une cueillette pour consulter la liste des magasin
$(document).on('click', '#confirmService', function () {
    let $deliveryPostalCode = $('#deliveryPostalCode').val();
    let $choiceTypeService = $('.st__serviceType input[name="radioServiceTypeFromUpdatePanel"]:checked').val();
    let $updateTypeServiceFromPanel = $choiceTypeService === 'HOME_DELIVERY' ? 'DELIVERY' : 'PICKUP';

    let $timeslotUrl = serviceUrl + '?deliveryPostalCode=' + $deliveryPostalCode + '&updateTypeServiceFromPanel=' + $updateTypeServiceFromPanel;
    if ($updateTypeServiceFromPanel === 'DELIVERY') {
        $timeslotUrl += '&fromSubmit=' + true;
        if (isInCheckoutPage(true)) {
            $timeslotUrl +='&excludePreviewTimeslots=' + true;
        }
    } else if ($updateTypeServiceFromPanel === 'PICKUP') {
        let $selectedOption = $('#preSelectedPickupStores :selected');
        if ($selectedOption.length) {
            $timeslotUrl += '&pickupStoreId=' + $selectedOption.val() + '&fromSubmit=' + false;
            if (isInCheckoutPage(true)) {
                $timeslotUrl +='&excludePreviewTimeslots=' + true;
            }
        }
    }
    ServiceTimeslot.updatePostalCodeFromPanel($timeslotUrl);
    sessionStorage.setItem('enteredPostalCode', $deliveryPostalCode);
});

//Panneau modification afficher la liste des pickup
$(document).on('click', '.postalCode_submit_pickup_list', function () {
    let $deliveryPostalCode = $('#deliveryPostalCode').val();
    let $choiceTypeService = 'PICK_UP_IN_STORE';
    loadModifyPanel($choiceTypeService, $deliveryPostalCode);
});

$(document).on('click', '.postalCode_submit_delivery', function () {
    let $deliveryPostalCode = $('#deliveryPostalCode').val();
    let $choiceTypeService = 'EMPTY_SERVICE';
    loadModifyPanel($choiceTypeService, $deliveryPostalCode);
});

// handle delivery type with space key and enter on change choice type panel
$(document).on('keydown', '.st__serviceType label[for="pickUpRadioFromUpdatePanel"]', function (e) {
    if (e.key === 'Enter' || e.which === 13 || e.key === ' ' || e.key === 'Spacebar' || e.which === 32) {
        $('.st__serviceType label[for="pickUpRadioFromUpdatePanel"]').trigger('click');
    }
});

$(document).on('keydown', '.st__serviceType label[for="deliveryRadioFromUpdatePanel"]', function (e) {
    if (e.key === 'Enter' || e.which === 13 || e.key === ' ' || e.key === 'Spacebar' || e.which === 32) {
        $('.st__serviceType label[for="deliveryRadioFromUpdatePanel"]').trigger('click');
    }
});

//Panneau modification de CP
$(document).on('change', '.st__serviceType input[name="radioServiceTypeFromUpdatePanel"]', function () {
    if (this.value == 'PICK_UP_IN_STORE') {
        $('.postalCode_submit_pickup_list').removeClass('hide');
        $('.dropdown--list-stores').removeClass('hide');
    } else if (this.value == 'HOME_DELIVERY') {
        $('.postalCode_submit_pickup_list').addClass('hide');
        $('.dropdown--list-stores').addClass('hide');

        if ($('#deliveryPostalCode').length) {
            const postalCode = $('#deliveryPostalCode').val();
            if (postalCode.length !== 7) {
                let $confirmService = $('#confirmService');

                if ($confirmService.length) {
                    $confirmService.prop('disabled', true);
                }
            }
        }
    }
});

function confirmCloseDropdown() {
    let $variantSelector = $('.action__select-variant.active');
    if ($variantSelector.length) {
        $('.st--main.choice-modification').trigger('click');
    }
}

//Forcer la fermeture du panneau Modifier votre choix au clic sur le X
$(document).on('click', '#closePanelModifierChoixModal', function () {
    if (isInWebview()) {
        sendCloseWebviewEventToDevice('CANCELLATION');
        if ($('.st_panel.rightPanel.remodal-is-opened').length > 0) {
            $('.st_panel.rightPanel.remodal-is-opened').remodal().close();
        }
    } else {
        confirmCloseDropdown();
        $('.st_panel.rightPanel.remodal-is-opened').remodal().close();
    }
});

$(document).on('keydown', '.choice-modification #deliveryPostalCode', function (event) {
    if (event.key === "Enter" || event.keyCode === 13) {
        event.preventDefault(); // Prevent Enter from doing anything
        if ($('#deliveryRadioFromUpdatePanel:checked').length) {
            $('.sp_footer_actions #confirmService').trigger("click");
        } else if ($('#pickUpRadioFromUpdatePanel:checked').length) {
            $('.postalCode_submit_pickup_list').trigger("click");
        }
    }
});

const toggleServiceBtn = function () {
    let $serviceCheckbox = $('.st__serviceType input[name="radioServiceType"]');
    let $deliveryRadio = $('#deliveryRadio');
    let checkedService = $deliveryRadio.is(':checked');

    $serviceCheckbox.on('change', function () {
        checkedService = $deliveryRadio.is(':checked');
        toggleServiceAction(checkedService);
    });
    toggleServiceAction(checkedService);

    $('.tryPickUp').on('click', function () {
        let $choiceTypeService = $('.st__serviceType input[name="radioServiceType"]:checked').val();
        let $deliveryPostalCode = $('#deliveryPostalCode').val();

        if ($choiceTypeService === 'HOME_DELIVERY'){
            $choiceTypeService = 'PICK_UP_IN_STORE';
        } else if ($choiceTypeService === 'PICK_UP_IN_STORE'){
            $choiceTypeService = 'HOME_DELIVERY';
        }

        loadModifyPanel($choiceTypeService, $deliveryPostalCode);
    });

    $('.tryDelivery').on('click', function () {
        changeServiceStatusRedbox();
        $('#deliveryRadio').click();
    });

    $('#modifyCartItems').on('click', function () {
        closeServiceTimeslot();
        if (!isInCheckoutPage()) {
            MiniCart.getMiniCart();
        } else {
            location.href = shoppingCartUrl;
        }
    });
}

function changeServiceStatusRedbox() {
    const redPanelStatusImg = $('.st__serviceType .red-container img')[0];
    const redPanelStatusTitle = $('.st__serviceType .red-container .service-desc .title')[0];
    const redPanelStatusDestinationPostalCode = $('.st__serviceType .red-container .service-desc .destination-postal-code');
    const redPanelStatusDestinationStoreName = $('.st__serviceType .red-container .service-desc .destination-store-name');
    const redPanelStatusDescriptionLinkDelivery = $('.st__serviceType .red-container .description-link-delivery')
    const redPanelStatusDescriptionLinkPickup = $('.st__serviceType .red-container .description-link-pickup')

    if(redPanelStatusImg.src.includes('icon-notification-grocery.svg')){
        redPanelStatusImg.src = redPanelStatusImg.src.replace('icon-notification-grocery.svg', 'icon-notification-delivery.svg');
        if(lang === 'en'){
            redPanelStatusTitle.innerText = 'Delivery at ' + $('.from-pick-try-delivery .service-desc .destination').text();
        } else {
            redPanelStatusTitle.innerText = 'Livraison au ' + $('.from-pick-try-delivery .service-desc .destination').text();
        }
        redPanelStatusDescriptionLinkDelivery.show();
        redPanelStatusDescriptionLinkPickup.hide();
        redPanelStatusDestinationPostalCode.show();
        redPanelStatusDestinationStoreName.hide();

    } else {
        redPanelStatusImg.src = redPanelStatusImg.src.replace('icon-notification-delivery.svg', 'icon-notification-grocery.svg');
        if(lang === 'en'){
            redPanelStatusTitle.innerText = 'Pickup at';
        } else {
            redPanelStatusTitle.innerText = 'Cueillette au';
        }
        redPanelStatusDescriptionLinkDelivery.hide();
        redPanelStatusDescriptionLinkPickup.show();
        redPanelStatusDestinationPostalCode.hide();
        redPanelStatusDestinationStoreName.show();
    }
}

function closeAlertBtn() {
    $('.alert-close').on('click', function () {
        $(this).parent('.alert-container').addClass('hide');
        $(this).closest('.instaCartAlert').addClass('hide');
        $('.fix-alert-separation').removeClass('fix-alert-separation')
        $('#modal-service-and-timeslot').append($('.instaCartAlert'));
    });
}

const instaCartAlert = function ($inputSelected) {
    if (sidePanelControl.isDelivery() && $inputSelected.length) {
        let $instaCartAlert = $('.instaCartAlert');
        let inputInstacart = $inputSelected.is("[slot-delivery=instacart]");
        let inputInstacartExpress = $inputSelected.is("[slot-delivery=instacart-express]");
        let inputInstacartSameDay = $inputSelected.is("[slot-delivery=instacart-sameday]");
        if (inputInstacart || inputInstacartExpress || inputInstacartSameDay) {
            let $inputParent = $inputSelected.closest('li');
            $inputParent.prevAll('li').first().addClass('fix-alert-separation');
            $instaCartAlert.removeClass('hide');
            $instaCartAlert.children().removeClass('hide');
            $instaCartAlert.insertAfter($inputParent);
            setTimeout(function () {
                $('.instaCartAlert .alert-text').focus();
            }, 1000);
        } else {
            $('#modal-service-and-timeslot').append($instaCartAlert);
        }
    }
}

const instaCartAlertExpress = function ($inputSelected) {
    if (sidePanelControl.isDelivery() && $inputSelected.length) {
        let $instaCartAlertExpress = $('.alert-express');
        let inputInstacart = $inputSelected.is("[name=select-timeslot-express_delivery]");
        if (inputInstacart) {
            $instaCartAlertExpress.removeClass('hide');
            setTimeout(function () {
                $('.alert-container .alert-text').focus();
            }, 1000);
        }
    }
}

const displayTssGridOptions = function () {
    // conditions if not in Mprio mode -- display updates to timeslot
    if ($('.activeDaySlider').closest("[data-store-id]").attr('data-service-type') !== ServiceTimeslot.SERVICE_TYPE_MPRIORITY_DELIVERY) {
        let $elements = $('.select--delivery-service .lowest-fee-container, .express-delivery-choice, .alert-container.alert-express.alert-white, .fastest-tag, .cheapest-tag');
        let $lowestFeeContainer = $('.select--delivery-service .lowest-fee-container');
        let $categoryTagExpress = $('.category-tag-express').first();
        // elements to display on Today only
        if ($('.activeDaySlider .day-selection_btn.day__active').text() == 'Today' || $('.activeDaySlider .day-selection_btn.day__active').text() == 'Aujourd\'hui') {
            $lowestFeeContainer.show();
            $elements.css('display', 'flex');
            $categoryTagExpress.css('display', 'flex');
        } else {
            $lowestFeeContainer.hide();
            $elements.css('display', 'none');
            $categoryTagExpress.css('display', 'none');
            // if only express timeslot and no days row displayed
            if (!$('.activeDaySlider').length) {
                $elements.css('display', 'flex');
                $categoryTagExpress.css('display', 'flex');
                $('.lowest-fee-container').css('display', 'none');
            }
        }

        // keep the first fastest only
        $('.fastest-tag:gt(0)').remove();
        // category tabs
        $('.activeTimeslotContainer .category-tag').first().css('display', 'flex');
        $('.activeTimeslotContainer .category-tag-partner').first().css('display', 'flex');
    } else {
        // In mpriority mode nothing is displayed except Uber only if there is no See all timeslots button
        if (($('.activeDaySlider .day-selection_btn.day__active').text() == 'Today' || $('.activeDaySlider .day-selection_btn.day__active').text() == 'Aujourd\'hui') &&
            $('.showAllTimeslotText:not(.hide)').length === 0 && $('.activeTimeslotContainer ul[class*=service-home_delivery]').length === 0) {
            $('.express-delivery-choice, .alert-container.alert-express.alert-white').css('display', 'flex');
            let $categoryTagExpress = $('.category-tag-express').first();
            $categoryTagExpress.css('display', 'flex');
            $('ul[class*=service-mpriority] .category-tag-partner, .lowest-fee-container, .activeTimeslotContainer .category-tag').css('display', 'none');
        } else {
            $('ul[class*=service-mpriority] .category-tag-partner, .lowest-fee-container, .activeTimeslotContainer .category-tag, .category-tag-express, .alert-container.alert-express.alert-white, .radio--standard.express-delivery-choice').css('display', 'none');
        }
    }
}

function setGaDataTypes(inputElm) {
    if (inputElm.id == 'pickUpRadio') {
        sidePanelControl.hideExpressAlert();
    } else if ($(inputElm).hasClass('standard-timeslots-express_delivery')) {
        $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type', 'eclair');
        sidePanelControl.manageAlertDisplay($(inputElm));
    } else if ($(inputElm).hasClass('standard-timeslots-home_delivery')) {
        if ($(inputElm).closest('.timeslotDayGroup.fromNoRush').length) {
            $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type', 'econo');
        } else if ($(inputElm).attr('slot-delivery') === 'instacart-express') {
            $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type', 'express');
        } else if ($('.activeDaySlider .day-selection_btn.day__active').text() == 'Demain' || $('.activeDaySlider .day-selection_btn.day__active').text() == 'Tomorrow') {
            let $elements = $('.select--delivery-service .lowest-fee-container, .express-delivery-choice, .alert-container.alert-express.alert-white, .fastest-tag, .cheapest-tag');
            if (typeof $elements != 'undefined') {
                $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type', 'econo');
            }
        } else {
            $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type', 'regular');
        }

        sidePanelControl.manageAlertDisplay($(inputElm));
    } else if ($(inputElm).hasClass('standard-timeslots-pick_up_in_store')) {
        $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type', 'regular');
    } else if ($(inputElm).hasClass('standard-timeslots-mpriority_pickup')) {
        $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type', 'mpriority');
        sidePanelControl.manageAlertDisplay($(inputElm));
    } else if ($(inputElm).hasClass('standard-timeslots-mpriority_home_delivery')) {
        $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type', 'mpriority');
        sidePanelControl.manageAlertDisplay($(inputElm));
    }
}

function getRadioOnChange() {
    $('#modal-service-and-timeslot input').on('change', function (e) {
        setGaDataTypes(e.target);
    });

    $('.activeTimeslotContainer input[type="radio"].standard-timeslots-home_delivery, input.standard-timeslots-express_delivery[type="radio"]').on('change', function () {
        let $this = $(this);
        if ($this.prop('checked')) {
            $('.alert-close').trigger('click');
            instaCartAlert($this);
            instaCartAlertExpress($this);
        }
    });
}


// OPEN SERVICE TIMESLOT PANEL FUNCTION
const $remodal = $('div[data-remodal-id="serviceTimeSlotPanel"]');
const openServiceTimeslot = function () {
    $remodal.addClass('in-progress');
    $remodal.remodal().open();
    if ($remodal.state === 'closed') {
        $remodal.remodal().open();
    }
};

const closeServiceTimeslot = function () {
    confirmCloseDropdown();
    $remodal.remodal().close();
};

const initServiceTimeslot = function () {
    if ($('#noService').length && $('#confirmService').length) {
        $('#confirmService').prop('disabled', true);
    }
    let $inputPostalCode = $('#deliveryPostalCode');
    $('.pickup-store-select').accordion_default();
    showOverlayServiceBox.removeOverlayServiceBox();
    formatServicePostalCode.formatInput($inputPostalCode, SERVICE_TIMESLOT);

    serviceTimeslotControl.initTimeslotDaySlider();
    sidePanelControl.displayCorrectTimeslotDay(true);
    sidePanelControl.storeSelectToggle();
    sidePanelControl.initServiceTypeExpressDelivery();
    toggleServiceBtn();
    closeAlertBtn();
    getRadioOnChange();
    $remodal.removeClass('in-progress');
    $('#modal-service-and-timeslot').removeClass('in-progress');
}

// CYBERMETRIE
const gaEventGetServiceType = function (checkoutPage) {
    let serviceType;
    if (!checkoutPage) {
        serviceType = $('.data-container-GA .data-service-type-GA').data('ga-service-type');
    } else {
        serviceType = $('#step input[name="grocery.type"]').val();
        if (!$('.data-container-GA .data-service-type-GA').length) {
            $('.data-container-GA').append($('<span/>', {'class': 'data-service-type-GA', 'data-ga-service-type': serviceType}));
        }
    }
    return serviceType;
}

const gaEventGetPartnerType = function () {
    let serviceType = ServiceTimeslot.getCurrentServiceType();
    let partnerType;


    if (serviceType === ServiceTimeslot.SERVICE_TYPE_ECOMM_DELIVERY) {
        let $timeslotInput = $('.service-timeslot input:checked');
        partnerType = 'metro';

        if ($timeslotInput.hasClass('instacart-slot')) {
            partnerType = 'instacart';
        }

    } else if (serviceType === ServiceTimeslot.SERVICE_TYPE_EXPRESS_DELIVERY) {
        partnerType = 'cornershop';
    }

    return partnerType;
}

const gaEventGetTimeslotType = function (checkoutPage) {
    let timeslotType;
    if (!checkoutPage) {
        timeslotType = $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type');
    } else {
        timeslotType = $('#step input[name="serviceType"]').val();

        if (timeslotType == 'HOME_DELIVERY') {
            timeslotType = 'regular';
        } else if (timeslotType == 'PICK_UP_IN_STORE') {
            timeslotType = 'regular';
        } else if (timeslotType == 'CORNERSHOP_HOME_DELIVERY') {
            timeslotType = 'eclair';
        } else if (timeslotType == 'MPRIORITY_PICKUP') {
            timeslotType = 'mpriority';
        } else {
            timeslotType = 'empty';
        }

        if (!$('.data-container-GA .data-timeslot-type-GA').length) {
            $('.data-container-GA').append($('<span/>', {'class': 'data-timeslot-type-GA', 'data-ga-timeslot-type': timeslotType}));
        }
    }
    return timeslotType;
}

const gaEventVisibleSlots = function (serviceType) {
    let availability;
    if ($('.activeTimeslotContainer .timeslotDayGroup:not(.timeslot-group-inactive):not([class*=service-mpriority]) li').length > 0 || $('.showAllTimeslotText:not(.hide)').length > 0) {
        availability = serviceType + ' - regular';
    } else {
        availability = 'empty';
    }

    if ($('.select--delivery-service:not(.hide) .express-delivery-choice').length > 0) {
        if (availability === 'empty') {
            availability = serviceType + ' - eclair';
        } else {
            availability += ',' + serviceType + ' - eclair';
        }
    }

    let $elements = $('.lowest-fee-container .cheapest-tag');
    let $mprioElement = $('.activeTimeslotContainer .timeslotDayGroup:not(.timeslot-group-inactive):not([class*=service-mpriority])').length > 0;
    let lowestFee = $mprioElement && serviceType === 'delivery' && typeof $elements != 'undefined' && $elements.length > 0 && ($elements.css('display') === 'flex' || $elements.css('display') === 'none');
    if (lowestFee) {
        if (availability === 'empty') {
            availability = serviceType + ' - econo';
        } else {
            availability += ', ' + serviceType + ' - econo';
        }
    }

    if ( $('.activeTimeslotContainer .timeslotDayGroup:not(.timeslot-group-inactive):not([class*=service-mpriority]) li:has([slot-delivery="instacart-express"])').length > 0) {
        if (availability === 'empty') {
            availability = serviceType + ' - express';
        } else {
            availability += ', '+serviceType + ' - express';
        }
    }
    if ($('.activeTimeslotContainer ul[class*=service-mpriority]:not(.timeslot-group-inactive) li').length > 0 || $('.showFlexibleText:not(.hide)').length > 0) {
        if (availability === 'empty') {
            availability = serviceType + ' - mpriority';
        } else {
            availability += ', '+ serviceType + ' - mpriority';
        }
    }

    return availability;
}

const onPanelView = function (origin, checkoutPage) {
    let serviceType = gaEventGetServiceType(checkoutPage);
    let timeslotType = gaEventGetTimeslotType(checkoutPage);
    $('.data-service-type-GA').data('ga-service-type', serviceType);
    $('.data-timeslot-type-GA').data('ga-timeslot-type', timeslotType);
    $('.data-origin-GA').data('origin-ga', origin);
}

const panelViewGAPush = function () {
    let $inputPostalCode = $('#deliveryPostalCode').val();
    if ($inputPostalCode.length === 0 || $inputPostalCode.length === 3) {
        pannelIsOpen = true

        let origin = $('.data-origin-GA').data('origin-ga')
        if (origin === 'cart genius') {
            gaNoCompletePostalCodePushOnPanelView('cart genius', 'unknown - no postal code', 'empty');
        } else {
            gaNoCompletePostalCodePushOnPanelView('sticky bar', 'unknown - no postal code', 'empty');
        }
    } else {
        let serviceType = $('.data-service-type-GA').data('ga-service-type');
        let timeslotType = $('.data-timeslot-type-GA').data('ga-timeslot-type');
        if (($('.activeDaySlider .day-selection_btn.day__active').text() == 'Demain' || $('.activeDaySlider .day-selection_btn.day__active').text() == 'Tomorrow')
            && serviceType === 'delivery' && timeslotType === 'regular') {
            let $elements = $('.lowest-fee-container');
            if (typeof $elements != 'undefined') {
                timeslotType = 'econo';
            }
        }
        let origin = $('.data-origin-GA').data('origin-ga');
        let location = window.location.href;
        if (typeof origin == 'undefined') {
            if (location.indexOf('mon-panier') !== -1 || location.indexOf('my-cart') !== -1) {
                origin = 'cart';
            } else {
                origin = 'mini-cart';
            }
        }
        let availability = gaEventVisibleSlots(serviceType);
        gaPushOnPanelView(origin, serviceType, timeslotType, availability);
    }
}

const onPanelServiceClick = function (elmText) {
    let serviceType = gaEventGetServiceType(false);
    let partnerType = gaEventGetPartnerType();
    let timeslotType = gaEventGetTimeslotType(false);
    gaPushOnPanelServiceClick(elmText, serviceType, partnerType, timeslotType);
}

const onPanelClose = function () {
    let $inputPostalCode = $('#deliveryPostalCode').val();
    if ($inputPostalCode.length === 0 || $inputPostalCode.length === 3) {
        pannelIsOpen = true;
        gaNoCompletePostalCodePushOnPanelClose('unknown - no postal code', 'empty');
    } else {
        let serviceType = gaEventGetServiceType(false);
        let timeslotType = gaEventGetTimeslotType(false);
        let availability = gaEventVisibleSlots(serviceType);
        gaPushOnPanelClose(serviceType, timeslotType, availability);
    }
}